var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}.c{fill:#4c4c4e;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 55.067,
    height: 55.067
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.349 9.379)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.64,10.371v-3.5a36.074,36.074,0,0,1-19.953,0v3.5A36.074,36.074,0,0,0,32.64,10.371Z",
    transform: "translate(0.273 -6.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.1,9.438l12.79,27.541c-4.519,4.775-8.527,2.387-10.829,2.387-4.263,0-5.969,2.387-12.023,2.387s-7.674-2.387-12.023-2.387c-2.3,0-6.31,2.387-10.829-2.387L15.978,9.438",
    transform: "translate(-3.187 -5.942)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.115 7.226)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M23.745,13.557a1.212,1.212,0,0,1-.512-.171,1.212,1.212,0,0,1-.171-.512,1.212,1.212,0,0,1,.171-.512.669.669,0,0,1,.938,0,.914.914,0,0,1,.171.512,1.212,1.212,0,0,1-.171.512A.651.651,0,0,1,23.745,13.557Z",
    transform: "translate(-23.063 -12.172)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.666 2.563)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M25.954,33.167a.7.7,0,0,1,.426-.853h0a.589.589,0,0,1,.853.426h0a.7.7,0,0,1-.426.853h-.256C26.3,33.678,26.04,33.508,25.954,33.167Zm-.767-2.643a.623.623,0,0,1,.512-.767h0a.756.756,0,0,1,.853.512h0a.623.623,0,0,1-.512.767h-.171C25.528,31.12,25.272,30.865,25.187,30.524Zm-.426-2.558h0a.664.664,0,0,1,.6-.767h0a.664.664,0,0,1,.767.6h0a.664.664,0,0,1-.6.767h-.085A.826.826,0,0,1,24.761,27.965Zm-.341-2.643a.819.819,0,0,1,.6-.767h0a.819.819,0,0,1,.767.6h0a.819.819,0,0,1-.6.767H25.1A.724.724,0,0,1,24.42,25.322Zm-.171-2.643a.819.819,0,0,1,.6-.767h0a.819.819,0,0,1,.767.6h0a.819.819,0,0,1-.6.767h-.085A.659.659,0,0,1,24.249,22.679Zm-.171-2.643a.808.808,0,0,1,.682-.767h0a.659.659,0,0,1,.682.6h0a.659.659,0,0,1-.6.682h-.085A.546.546,0,0,1,24.078,20.036Zm-.256-2.643h0a.819.819,0,0,1,.6-.767h0a.819.819,0,0,1,.767.6h0a.819.819,0,0,1-.6.767H24.5C24.164,18.074,23.908,17.733,23.823,17.392Zm-.256-2.558h0a.664.664,0,0,1,.6-.767h0a.664.664,0,0,1,.767.6h0a.664.664,0,0,1-.6.767h-.085A.659.659,0,0,1,23.567,14.834Z",
    transform: "translate(-23.551 -14.051)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.263 23.022)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M26.87,30.432a1.212,1.212,0,0,1-.512-.171.853.853,0,0,1,0-1.023.669.669,0,0,1,.938,0,.853.853,0,0,1,0,1.023A.651.651,0,0,1,26.87,30.432Z",
    transform: "translate(-26.188 -29.047)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.216 7.226)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.682,13.557a1.212,1.212,0,0,1-.512-.171A1.212,1.212,0,0,1,16,12.875a1.212,1.212,0,0,1,.171-.512.669.669,0,0,1,.938,0,.914.914,0,0,1,.171.512,1.212,1.212,0,0,1-.171.512A.651.651,0,0,1,16.682,13.557Z",
    transform: "translate(-16 -12.172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.257 2.579)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.245,33.589a.747.747,0,0,1-.426-.853h0a.7.7,0,0,1,.853-.426h0a.7.7,0,0,1,.426.853h0a.675.675,0,0,1-.682.426h0C14.415,33.674,14.33,33.589,14.245,33.589Zm.853-2.473a.709.709,0,0,1-.512-.853h0a.709.709,0,0,1,.853-.512h0a.709.709,0,0,1,.512.853h0a.648.648,0,0,1-.682.512H15.1Zm.512-2.643c-.341-.085-.682-.426-.6-.767h0a.819.819,0,0,1,.767-.6h0a.819.819,0,0,1,.6.767h0a.679.679,0,0,1-.767.6Zm.256-2.558a.638.638,0,0,1-.6-.767h0a.638.638,0,0,1,.767-.6h0a.638.638,0,0,1,.6.767h0a.689.689,0,0,1-.767.6Zm.256-2.643a.638.638,0,0,1-.6-.767h0a.638.638,0,0,1,.767-.6h0a.638.638,0,0,1,.6.767h0a.747.747,0,0,1-.767.6Zm.171-2.643a.6.6,0,0,1-.6-.682h0a.638.638,0,0,1,.767-.6h0a.638.638,0,0,1,.6.767h0a.773.773,0,0,1-.767.512Zm.171-2.558a.638.638,0,0,1-.6-.767h0a.638.638,0,0,1,.767-.6h0a.679.679,0,0,1,.6.767h0a.756.756,0,0,1-.767.6Zm.256-2.643a.819.819,0,0,1-.6-.767h0a.819.819,0,0,1,.767-.6h0a.819.819,0,0,1,.6.767h0a.724.724,0,0,1-.682.6h-.085Z",
    transform: "translate(-13.797 -14.063)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.022)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.557,30.432a1.212,1.212,0,0,1-.512-.171.853.853,0,0,1,0-1.023.669.669,0,0,1,.938,0,.914.914,0,0,1,.171.512,1.212,1.212,0,0,1-.171.512A.651.651,0,0,1,13.557,30.432Z",
    transform: "translate(-12.875 -29.047)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkirt);
export default __webpack_public_path__ + "static/media/Skirt.be2e1f6fdfb7be2c34708ae9099cbadc.svg";
export { ForwardRef as ReactComponent };